import PropTypes from 'prop-types';
import styled from 'styled-components';
import { buildStyledComponent, px2rem } from 'decisiv-ui-utils';

/* istanbul ignore next */
const styles = props => `
  color: ${props.theme.colors.base.text};
  padding: ${px2rem(13)} ${px2rem(18)} ${px2rem(13)} ${px2rem(12)};
`;

const themePropTypes = {
  colors: PropTypes.shape({
    base: PropTypes.shape({
      text: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default buildStyledComponent(
  'StatusPopoverContent',
  styled.div,
  styles,
  { themePropTypes },
);



// WEBPACK FOOTER //
// ./components/CaseDisplayElement/StatusPopoverContent.js